<template>
    <component
        :is="currentComponent"
        v-if="currentComponent"
        v-bind="$props"
        ref="ClosingInformationModalChild"
        @save="$emit('save')"
    />
</template>
<script>

export default {
    name: 'ClosingInformationModal',
    components: {
        v1: async () => await import('./v1/ClosingInformationModal'),
        v2: async () => await import('./v2/ClosingInformationModal'),
        v3: async () => await import('./v3/ClosingInformationModal'),
    },
    props: {
        version: {
            type: String,
            default: 'v1'
        },
        orderAppResource: {
            type: Object,
        },
    },
    data: () => ({}),
    computed: {
        currentComponent() {
            return this.version || 'v1';
        },
    }
}
</script> 